export enum PitchListDialog {
  // confirm
  DeleteList = 'DeleteList',
  DeletePitches = 'DeletePitches',

  // list
  RenameFolder = 'RenameFolder',

  // selected pitch
  Data = 'Data',
  Edit = 'Edit',

  EditBreaks = 'EditBreaks', // ! deprecate
  EditSpins = 'EditSpins', // ! deprecate
  Optimize = 'Optimize', // ! deprecate

  // manage pitches
  ChangeVideo = 'ChangeVideo',
  Copy = 'Copy',
  Reset = 'Reset',
  ReorderList = 'Reorder',
  Training = 'Training',

  // misc
  Search = 'Search',
}
